import { Box, Typography } from '@mui/material'
import GoBackButton from 'components/GoBackButton/GoBackButton'
import theme from 'lib/theme'
import { FC, ReactNode } from 'react'
import { Wrapper } from './elements'

type SecondarySidebarProps = {
  header: string
  subtitle?: string
  subtitle2?: string
  onGoBackClick: () => void
  selectOptionsBtn?: ReactNode
  scrollable?: boolean
}

const SecondarySidebar: FC<SecondarySidebarProps> = ({
  header,
  subtitle,
  subtitle2,
  children,
  onGoBackClick,
  selectOptionsBtn,
  scrollable,
}) => {
  return (
    <Wrapper scrollable={Boolean(scrollable)}>
      <nav>
        <Box display='flex' justifyContent='space-between'>
          <GoBackButton onClick={onGoBackClick} />
          {selectOptionsBtn}
        </Box>
        <Box mt={2} mb={5}>
          <Typography variant='h2' color={theme.palette.primary.main}>
            {header}
          </Typography>
          {subtitle && (
            <Typography
              variant='subtitle2'
              color={theme.palette.text.secondary}
              mt={1}>
              {subtitle}
            </Typography>
          )}
          {subtitle2 && (
            <Typography variant='body1' mt={1}>
              {subtitle2}
            </Typography>
          )}
        </Box>
        {children}
      </nav>
    </Wrapper>
  )
}

export default SecondarySidebar
